import { useEffect, useState } from "react";
import { Save, Palette } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import ImageUpload from "@/components/ImageUpload";

const inputCls = "w-full rounded-lg border border-input bg-[#060B18] px-3 py-2 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500";

export default function AppearanceTab() {
  const [theme, setTheme] = useState({ hero_image: "", bg_image: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/theme").then((r) => setTheme(r.data)).catch((e) => toast.error(errMsg(e))).finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/theme", theme);
      toast.success("Apparence mise à jour");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (loading) return <p className="text-slate-500">Chargement...</p>;

  return (
    <form onSubmit={save} className="card-tactical grid max-w-2xl gap-4 p-6" data-testid="admin-theme-form">
      <p className="flex items-center gap-2 font-heading text-lg font-bold uppercase">
        <Palette className="h-5 w-5 text-orange-500" /> Fonds du site
      </p>
      <label className="text-xs font-bold uppercase tracking-widest text-slate-400">
        Image de fond de l'accueil (héro)
        <input value={theme.hero_image} data-testid="admin-hero-image-input"
          placeholder="https://... (laissez vide pour l'image par défaut)"
          onChange={(e) => setTheme({ ...theme, hero_image: e.target.value })} className={inputCls + " mt-1"} />
      </label>
      <ImageUpload testid="admin-hero-image-upload" onUploaded={(url) => setTheme((t) => ({ ...t, hero_image: url }))} />
      {theme.hero_image && (
        <img src={theme.hero_image} alt="Aperçu héro" className="h-32 w-full rounded-lg border border-orange-500/20 object-cover" />
      )}
      <label className="text-xs font-bold uppercase tracking-widest text-slate-400">
        Image de fond globale (toutes les pages, très discrète)
        <input value={theme.bg_image} data-testid="admin-bg-image-input"
          placeholder="https://... (laissez vide pour aucun fond)"
          onChange={(e) => setTheme({ ...theme, bg_image: e.target.value })} className={inputCls + " mt-1"} />
      </label>
      <ImageUpload testid="admin-bg-image-upload" onUploaded={(url) => setTheme((t) => ({ ...t, bg_image: url }))} />
      {theme.bg_image && (
        <img src={theme.bg_image} alt="Aperçu fond global" className="h-32 w-full rounded-lg border border-orange-500/20 object-cover" />
      )}
      <p className="text-xs text-slate-500">
        Collez l'URL d'une image (ex. photo de votre setup, LAN, ou artwork). Le fond global s'affiche en transparence derrière le bleu nuit.
      </p>
      <button type="submit" data-testid="admin-theme-save-button"
        className="flex w-fit items-center gap-2 rounded-lg bg-orange-500 px-5 py-2.5 text-sm font-bold uppercase text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400">
        <Save className="h-4 w-4" /> Enregistrer
      </button>
    </form>
  );
}
